import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const IMPORTED_DATA_ROUTE_NAME = Symbol('imported-data.list');
export const TRANSLATION_GROUPS_OF_IMPORTED_DATA = Symbol('imported-data');

export const IMPORTED_DATA_QUERY_KEY = 'imported-data.list';
export const IMPORTED_DATA_API_URL = 'admin/ftp_files/list';

export const IMPORTED_DATA_MUTATION_KEY = 'imported-data.download';
export const IMPORTED_DATA_MUTATION_API_URL = 'admin/ftp_files/:id/download_link';

export const IMPORTED_DATA_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.FTPFILES_SHOW),
};
